import '../../assets/css/DeleteProcessPage.css';

const DeleteProcessPage = () => {

    return (
        <>
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-8 col-lg-6">
                        <div class="card delete-card">
                            <div class="card-body p-5 text-center">

                                <div class="mb-4">
                                    <i class="fas fa-exclamation-triangle warning-icon"></i>
                                </div>


                                <h1 class="delete-title h2 mb-4">About Delete App</h1>


                                <div class="alert store-data-alert" role="alert">
                                    <i class="fas fa-info-circle me-2"></i>
                                    <strong>Important:</strong> We have your store data. This account is not deleted permanently.
                                </div>


                                <div class="alert soft-delete-info" role="alert">
                                    <h5 class="alert-heading mb-3">
                                        <i class="fas fa-cog me-2"></i>Soft Delete Process:
                                    </h5>
                                    <ol class="delete-steps text-start">
                                        <li>Click the delete button below</li>
                                        <li>Confirm your decision when prompted</li>
                                        <li>Your account will be deactivated (soft delete)</li>
                                        <li>Your data remains stored and can be recovered</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default DeleteProcessPage;